import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomInputWrapper, CustomInputWrapperProps, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

type Props = CustomInputWrapperProps & {
    message?: string;
};

const GenericInput: InputWithMeta<Props> = (props: Props) => {
    const { input, message, ...rest } = props;

    return (
        <CustomFormItem name={input.guid} required={input.required} message={message} isReadOnly={input.isReadOnly}>
            <CustomInputWrapper input={input} topRightNode={<InputControls input={input} />} {...rest} />
        </CustomFormItem>
    );
};

GenericInput.meta = {
    inputType: InputModel.name
};

export default observer(GenericInput);
